//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/termos-de-uso',
      en: '/terms-of-use',
      es: '/terminos-de-uso'
    }
  },

  asyncData({ store, error }) {
    const terms = store.getters['layout/getTerms']

    if (terms) {
      return {
        terms
      }
    } else {
      return error({ statusCode: 404 })
    }
  },

  data() {
    return {
      terms: ''
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('title')
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/termos-de-uso'
        }
      ]

      return breadcrumbs
    }
  }
}
